import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import LoadingComponent from '@Common/loading';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import * as util from '@Util';
import ReactGA from 'react-ga';
import tagManager from '@Constants/tagManager';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '@Locales/config/components/login';

import ReCAPTCHAv2 from 'react-google-recaptcha';
class Form extends Component {
  componentDidUpdate() {
    if (
      window.document.getElementsByClassName('grecaptcha-badge')[0] &&
      !window.document
        .getElementsByClassName('grecaptcha-badge')[0]
        .classList.contains('grecaptcha-show')
    ) {
      window.document
        .getElementsByClassName('grecaptcha-badge')[0]
        .classList.add('grecaptcha-show');
    }
  }
  inputBlur = inputName => e => {
    const value = e.target.value;
    if (value.length > 0 && Object.values(tagManager.LOGIN.LABELS).includes(inputName)) {
      ReactGA.event({
        category: tagManager.LOGIN.CATEGORY,
        action: tagManager.LOGIN.ACTIONS.LOGIN_FIELDS,
        label: inputName
      });
    }
  }

  onSubmit = values => {
    ReactGA.event({
      category: tagManager.LOGIN,
      action: tagManager.LOGIN.ACTIONS.SIGNIN_CLICK,
      label: tagManager.LOGIN.LABELS.SIGNIN
    });
    const { recaptchaToken, showV2 } = this.props;
    this.props.onSubmit({ ...values, gRecaptchaResponse: recaptchaToken, v2: showV2 });
    new Promise(() =>
      this.props
        .executeRecaptcha()
        .then(() => {
          return;
        })
        .catch(e => {
          toastr.warning(
            this.props.intl.formatMessage(messages.attention),
            this.props.intl.formatMessage(messages.recaptchaProblem)
          );
        })
    );
  };

  render() {
    const {
      isLoading,
      validation,
      classes,
      recaptchaHasLoaded,
      handleSubmit,
      intl,
      handleV2Change,
      showV2,
      recaptchaV2SiteKey,
      recaptchaV2Selected
    } = this.props;

    if (!recaptchaHasLoaded)
      return (
        <div className={classes.blockUi}>
          <LoadingComponent message={intl.formatMessage(messages.secureEnvironment)} />
        </div>
      );

    return (
      <form onSubmit={handleSubmit(this.onSubmit)}>
        <div>
          <Field
            type="text"
            name="email"
            placeholder={intl.formatMessage(messages.email)}
            label={<FormattedMessage {...messages.email} />}
            onBlur={this.inputBlur('email')}
            error={validation.email || validation.emailFormat}
            className={classes.textField}
            InputProps={{
              classes: { input: classes.input }
            }}
            InputLabelProps={{ shrink: true }}
            validate={[util.email, util.required]}
            component={this.renderField}
          />
          {validation.email ? (
            <FormHelperText className={classes.errorText}>
              <FormattedMessage {...messages.invalidEmail} />
            </FormHelperText>
          ) : (
            ''
          )}
        </div>

        <div>
          <Field
            type="password"
            name="password"
            placeholder={intl.formatMessage(messages.password)}
            onBlur={this.inputBlur('password')}
            label={<FormattedMessage {...messages.password} />}
            error={validation.password || validation.passwordFormat}
            className={classes.textField}
            InputProps={{
              classes: { input: classes.input }
            }}
            InputLabelProps={{ shrink: true }}
            validate={[util.required, util.minLength6]}
            component={this.renderField}
          />
          {validation.password && !validation.passwordFormat ? (
            <FormHelperText className={classes.errorText}>
              <FormattedMessage {...messages.invalidPassword} />
            </FormHelperText>
          ) : (
            ''
          )}
        </div>

        <Grid container direction={'column'}>
          <Grid item>
            <Fab
              type={'submit'}
              variant={'extended'}
              color={'primary'}
              className={classes.buttonSubmit}
              classes={{ root: classes.raisedPrimaryOverrideButton }}
              disabled={isLoading || (!recaptchaV2Selected && showV2)}
            >
              {isLoading ? <FormattedMessage {...messages.wait} /> : <FormattedMessage {...messages.enter} />}
            </Fab>
          </Grid>

          <Grid container justify="center">
            {/* <Grid item lg={6} md={6} sm={12} xs={12}>
              <span
                className={classes.buttonRegisterlabel}
                onClick={this.redirectRouteRegister}
              >
                {' '}
                Nova conta{' '}
              </span>
            </Grid> */}
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className={classes.mobileTopMargin}
            >
              <span
                className={classes.buttonRegisterlabel}
                onClick={this.redirectRouteRecover}
              >
                {' '}
                <FormattedMessage {...messages.recoverPassword} />{' '}
              </span>
            </Grid>

            {showV2 && (
                <div style={{ marginTop: 20 }}>
                  <ReCAPTCHAv2
                    sitekey={recaptchaV2SiteKey}
                    onChange={handleV2Change}
                  />
                </div>
              )}
          </Grid>
        </Grid>
      </form>
    );
  }

  renderField = ({ input, meta: { touched, error }, ...custom }) => {
    const { classes } = this.props;
    return (
      <Fragment>
        <TextField {...input} {...custom} variant="outlined" />
        {touched &&
          error && (
            <FormHelperText className={classes.errorText}>
              {' '}
              {error}
            </FormHelperText>
          )}
      </Fragment>
    );
  };

  // Redirect to Register Route
  // redirectRouteRegister = () => {
  //   this.props.history.push('/register');
  // };

  redirectRouteRecover = () => {
    this.props.history.push('/recover');
  };
}

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  validation: PropTypes.shape({
    email: PropTypes.bool.isRequired,
    emailFormat: PropTypes.bool.isRequired,
    password: PropTypes.bool.isRequired,
    passwordFormat: PropTypes.bool.isRequired
  }).isRequired,
};

export default reduxForm({ form: 'SignIn' })(withRouter(injectIntl(Form)));
